import { Expose } from 'class-transformer'
import { PromotionCodeJobStatusEnum } from '@interfaces/promotionCode/PromotionCodeJobStatusEnum'

export class GenerateCouponsType {
  @Expose() generateCouponStatus?: PromotionCodeJobStatusEnum
}
